'use client';

import { DotBlockEditor } from '@/components/shared/decodeTextBlock';
import customRenderers from '@/components/block-editor';

export default function FeatureDetail({ featureDescription }) {
    if (!featureDescription) return null;

    return (
        <div className="prose prose-sm max-w-none prose-h2:text-2xl prose-h3:text-xl">
            <DotBlockEditor blocks={featureDescription} customRenderers={customRenderers} />
        </div>
    );
}
